import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { optional, record, string, } from "@discovery/prelude/lib/data/validated";
import { _ShowDetails, _ShowsCollection, _VideosCollection } from "../optics";
export const _ContentGridViewAll = Fold.alt(_VideosCollection, _ShowsCollection);
export const _PosterData = Fold.concat(_ShowsCollection, _VideosCollection);
export const Title = Fold.compose(Optics._Col2Items, Optics._ColItem2Show, Res._Response(), Lens.path("attributes", "name"));
const bannerCustomAttrValidator = optional(record({
    adUnitPath: string,
}));
export const BannerIdM = Fold.compose(Fold.pre(Optics._GetCustomAttributesForComponent(bannerCustomAttrValidator)), M._Just(), M._Just(), Lens.prop("adUnitPath"));
export const _MandatoryParams = Fold.compose(Optics._Col2Attributes, Lens.prop("component"), M._Just(), Lens.prop("mandatoryParams"));
export const SuperStarFeaturedShow = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Traversal._filteredOn(Optics._Col2ComponentId, (id) => id === "carousel"), Optics._Col2Items, Res._Rel("show"), _ShowDetails);

